import React from 'react'
import { useSelector } from 'react-redux'
import DocumentAreaWrapper from '../common/DocumentAreaWrapper'
import DocumentArea from '../features/components/DocumentArea'

const Loader = () => {
  const allPages = useSelector(({ pages }) => pages.all)

  return (
    <DocumentAreaWrapper>
      {allPages.map((page) => (
        <DocumentArea id={`page-${page.id}`} page={page.id} key={page.id} />
      ))}
    </DocumentAreaWrapper>
  )
}

export default Loader
